import { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { styled } from '@mui/system'
import DeleteIcon from '@mui/icons-material/RemoveCircle'
import IconButton from '@mui/material/IconButton'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import TextField from '@mui/material/TextField'
import { useRecordContext, useTranslate } from 'react-admin'
import { useFormContext } from 'react-hook-form'

const Td = styled('td')(() => ({}))
const Table = styled('table')(() => ({
  maxWidth: '400px',
  minWidth: '400px',
  border: '1px solid #c4c4c4',
  boxSizing: ' border-box',
  borderRadius: '5px',
  textAlign: 'left',
  tbody: {
    maxHeight: '250px',
    minHeight: '80px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: '2px',
      height: '2px',
    },
    '&::-webkit-scrollbar-button': {
      width: '0px',
      height: '0px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#e1e1e1',
      border: '0px none #ffffff',
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: '#ffffff',
    },
    '&::-webkit-scrollbar-thumb:active': {
      background: '#000000',
    },
    '&::-webkit-scrollbar-track': {
      background: '#666666',
      border: '0px none #ffffff',
      borderRadius: '50px',
    },
    '&::-webkit-scrollbar-track:hover': {
      background: '#666666',
    },
    '&::-webkit-scrollbar-track:active': {
      background: '#333333',
    },
    '&::-webkit-scrollbar-corner': {
      background: 'transparent',
    },
  },
  tr: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #c4c4c4',
    padding: '10px !important',
    fontSize: '12px',
    th: {},
    td: {
      '.icon_danger': {
        svg: {
          color: 'red',
        },
      },
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },
}))

export function ProcessType(props) {
  const record = useRecordContext(props)
  const [types, setTypes] = useState(record[props.source])
  const [type, setType] = useState('')
  const [error, setError] = useState(false)
  const { setValue } = useFormContext()
  const translate = useTranslate()

  useEffect(() => {
    setTimeout(() => {
      setValue('types', types)
    }, 400)
  }, [types])

  return (
    <Box sx={{ marginBottom: '20px' }}>
      <Box sx={{ marginBottom: '10px' }}>Configuration des types</Box>
      <Box></Box>
      <Table>
        <thead>
          <tr>
            <th>Type de processus</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tr>
          <Td sx={{ flex: '1' }}>
            <Box
              component="form"
              sx={{
                '& .MuiTextField-root': { m: 1, width: '100%' },
              }}
              noValidate
              autoComplete="off"
            >
              <TextField
                error={error}
                size="small"
                id="type"
                defaultValue={type}
                onChange={(e) => {
                  setError(false)
                  setType(e.target.value)
                }}
                value={type}
              />
            </Box>
          </Td>
          <Td>
            <IconButton
              component="button"
              color="primary"
              onClick={() => {
                if (type !== '') {
                  setTypes(types?.length ? [...types, type] : [type])
                  setType('')
                } else {
                  setError(true)
                }
              }}
            >
              <AddCircleIcon />
            </IconButton>
          </Td>
        </tr>
        <tbody>
          {types?.map((item) => {
            return (
              <tr>
                <Td>
                  {translate(`hs.tickets.type.${item}`, {
                    _: item,
                  })}
                </Td>
                <Td>
                  <IconButton
                    component="button"
                    className="icon_danger"
                    onClick={() => {
                      setTypes(
                        types.filter((itemFiltre) => itemFiltre !== item)
                      )
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    </Box>
  )
}
